exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labeled-input[data-v-2ee6104a] legend{font-weight:700}.labeled-input[data-v-2ee6104a] .bv-no-focus-ring,.labeled-input[data-v-2ee6104a] select{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ee6104a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/LabeledInput.vue
// module id = 899
// module chunks = 0